export default __webpack_public_path__ + "static/media/sh3riffIcon192.9e53f1ef.png";